import type {
	MessagePreviewRequest,
	MessagePreviewResponse,
} from "@/shared/api/generated/types/marketing"
import { getSmsInfo } from "@/widgets/marketing-message-block/model/sms-info"

import { getMarketingMediaUrl } from "./marketing-media-store"
import {
	buildMessagePreviewParts,
	buildPreviewText,
	MESSAGE_VARIABLES_FIXTURE,
} from "./marketing-message-variables-fixtures"

export function computeMessagePreviewFixture(
	body: MessagePreviewRequest,
): MessagePreviewResponse {
	const { len, seg } = getSmsInfo(body.text)
	const recipientCount = body.recipientCount ?? 0
	const previewMediaUrl = getMarketingMediaUrl(body.mediaId)
	const previewText = buildPreviewText({
		text: body.text,
		variables: MESSAGE_VARIABLES_FIXTURE,
	})
	const previewParts = buildMessagePreviewParts({
		text: body.text,
		previewMediaUrl,
		variables: MESSAGE_VARIABLES_FIXTURE,
	})

	return {
		charCount: len,
		parts: seg,
		estimatedBillableMessages:
			recipientCount > 0
				? recipientCount * seg
				: recipientCount === 0
					? 0
					: null,
		previewText,
		previewMediaUrl,
		previewParts,
	}
}
